import withValidation from './withValidation';

export default withValidation;
